<script>
export default {
  name: 'StandardItem',
}
</script>

<script setup>
import {computed} from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

// type
const type = computed({
  get () {
    switch (props.item.type) {
      case '刚进店': {
        return 'newbie'
      }

      case '在售': {
        return 'existed'
      }

      case '已预定': {
        return 'ordered'
      }

      case '已售': {
        return 'sold'
      }

      case '刚进店-已预定': {
        return 'newbie-ordered'
      }

      case '抢先报': {
        return 'early-access'
      }

      case '被秒': {
        return 'early-access-sold'
      }

      default: {
        return 'existed'
      }
    }
  },
})

const mileage = computed({
  get () {
    let mileage = props.item.mileage / 10000

    return mileage.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0]
  },
})
</script>

<template>
  <router-link
    class="standard-item-wrapper"
    :to="{
      name: 'carDetail',
      params: {
        id: item.id
      },
      query: {
        category: item.category
      }
    }">
    <div
      :class="[
        'car-cover-wrapper',
        type,
        item.market_tag ? 'market' : '',
        item.customer_location ? 'client' : '',
      ]">
      <template v-if="item.is_forestall">
        <div class="early-access-indicator">抢先</div>
      </template>
      <template v-if="item.car_condition_level">
        <div class="vehicle-rating-wrapper">
          <div
            v-if="item.car_condition_level === 'N+'"
            class="nuon-rating vehicle-rating--n-plus">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'N'"
            class="nuon-rating vehicle-rating--n">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'N-'"
            class="nuon-rating vehicle-rating--n-minus">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'B'"
            class="nuon-rating vehicle-rating--b">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'C+'"
            class="nuon-rating vehicle-rating--c-plus">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'C'"
            class="nuon-rating vehicle-rating--c">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'D+'"
            class="nuon-rating vehicle-rating--d-plus">
            {{ item.car_condition_level }}
          </div>
          <div
            v-else-if="item.car_condition_level === 'D'"
            class="nuon-rating vehicle-rating--d">
            {{ item.car_condition_level }}
          </div>
        </div>
      </template>
      <div class="car-indicators-wrapper">
        <div class="car-indicators">
          <template v-if="item.video">
            <div class="car-item-icon-video car-item-icon" />
          </template>
        </div>
      </div>
      <div
        v-lazy-container
        :class="['car-cover']">
        <img :data-src="`${item.cover}!/fw/640/rotate/auto/format/webp`">
      </div>
      <div
        v-show="item.loan_review"
        class="car-loan-reivew" />
      <div
        v-show="item.customer_location"
        class="car-client-wrapper">
        {{ item.customer_location }}
      </div>
      <template
        v-if="
          $route.params
            && $route.params.preview === 'preview'
            && item.vin">
        <div class="car-vin-wrapper">
          {{ item.vin }}
        </div>
      </template>
    </div>
    <div class="car-info-wrapper">
      <div class="car-title-wrapper">
        <template v-if="item.tags">
          <template
            v-for="(tag, index) in item.tags"
            :key="index">
            <template v-if="tag === '好车西运'">
              <div class="car-title-icon-perfix westward">
                <div class="car_titile__icon-perfix__text">好车西运</div>
              </div>
            </template>
            <template v-else-if="tag === '手动'">
              <div class="car-title-icon-perfix manual">
                <div class="car_titile__icon-perfix__text">手动</div>
              </div>
            </template>
            <template v-else-if="tag === '柴油'">
              <div class="car-title-icon-perfix diesel">
                <div class="car_titile__icon-perfix__text">柴油</div>
              </div>
            </template>
            <template v-else-if="tag === '新能源'">
              <div class="car-title-icon-perfix new-energy">
                <div class="car_titile__icon-perfix__text">新能源</div>
              </div>
            </template>
            <template v-else-if="tag === '瓦罐'">
              <div class="car-title-icon-perfix wagon">
                <div class="car_titile__icon-perfix__text">瓦罐</div>
              </div>
            </template>
            <template v-else-if="tag === '捡漏'">
              <div class="car-title-icon-perfix rare-one">
                <div class="car_titile__icon-perfix__text">捡漏</div>
              </div>
            </template>
            <template v-else-if="tag === '个人寄售'">
              <div class="car-title-icon-perfix personal-consignment">
                <div class="car_titile__icon-perfix__text">个人寄售</div>
              </div>
            </template>
          </template>
        </template>
        <div class="car-title">
          {{ item.title }}
        </div>
      </div>
      <div class="car-meta">
        {{ item.year }}<span class="car-meta__delimiter">·</span>{{ mileage }}万公里<span class="car-meta__delimiter">·</span>{{ item.emission }}*
      </div>

      <div class="car-price-location-wrapper">
        <div>
          <div class="car-price">
            <span class="current">
              {{ item.price.current }}
            </span>

            <template v-if="item.price.original">
              <span class="original">
                指导价：{{ item.price.original }}万
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
.standard-item-wrapper {
  cursor: pointer;
  margin: 0;
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-primary);
  background: var(--background);
  text-decoration: none;
}

.standard-item-wrapper:hover {
  filter: brightness(0.9);
}

.car-vin-wrapper {
  width: 100%;
  text-align: center;
  padding: 4px 0;
  box-sizing: border-box;
  font-size: .85rem;
  color: #676869;
  position: relative;
  z-index: 300;
  background: var(--background);
}

.car-info-wrapper {
  display: flex;
  overflow: hidden;
  flex: 2;
  box-sizing: border-box;
  flex-flow: column nowrap;
}

.car-title {
  display: inline;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  line-height: 1.125;
  text-overflow: ellipsis;
  font-size: 1.05rem;
  color: var(--black-primary);
  font-weight: bold;
  vertical-align: middle;
}

.car-meta {
  color: var(--black-secondary);
  width: auto;
  font-size: 0.8rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.car-meta__delimiter {
  margin: 0 4px;
}

.car-price-location-wrapper {
  margin-top: auto;
  display: flex;
  align-items: center;
  width: 100%;
  flex-flow: column nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.car-price-location-wrapper > div {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: space-between;
}

.car-price {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.car-price .current {
  color: var(--price-primary);
  font-weight: bold;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.car-price .original {
  color: var(--price-secondary);
  font-size: 0.75rem;
  margin-left: 10px;
  text-decoration: line-through;
  overflow: hidden;
  text-overflow: ellipsis;
  align-self: flex-end;
  line-height: 1;
}

.negotiation {
  background: #3FAAF7;
  color: #ffffff;
  display: inline-block;
  font-size: .85rem;
  padding: 1px 2px;
  box-sizing: border-box;
  margin-left: 8px;
}

.car-location {
  color: #108ee9;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;

  &.car-location-text-red {
    color: #e55627;
  }
}

// 金融优惠价 容器
.car-price-finance {
  margin-top: 4px;
}

.price-finance {
  padding: 3px 8px;
  box-sizing: border-box;
  background: #fd661d;
  color: #ffffff;
  display: inline-block;
  font-size: 0.7rem;
}

.car-title-wrapper {
  line-height: 1;
  margin-bottom: 4px;
}

.car-info-wrapper .car-title-icon-perfix {
  display: inline;
  margin-right: 4px;
  padding: 1px 9px;
  font-size: .75rem;
  color: #FFFFFF;
  border-radius: 10px 0 10px 0;
  // vertical-align: middle;
}

.car_titile__icon-perfix__text {
  font-weight: bold;
  display: inline-block;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, .4);
  line-height: 1;
}

/* 车辆标签-柴油 */
.car-info-wrapper  .car-title-icon-perfix.diesel {
  background: linear-gradient(0deg, #FDC507 0%, #FC3C2F 100%);
}

/* 车辆标签-新能源 */
.car-info-wrapper  .car-title-icon-perfix.new-energy {
  background: linear-gradient(0deg, #3DF14C 0%, #1DDC91 100%);
}

/* 车辆标签-手动 */
.car-info-wrapper  .car-title-icon-perfix.manual {
  background: linear-gradient(0deg, #0FC3FC 0%, #2599F6 100%);
}

/* 车辆标签-wagon */
.car-info-wrapper  .car-title-icon-perfix.wagon {
  background: linear-gradient(0deg, #DC71FC 0%, #880AFE 100%);
}

// 车辆标签-好车西运
.car-info-wrapper .car-title-icon-perfix.westward {
  background: linear-gradient(0deg, #FFDC81 0%, #C3914D 100%);
}

/* 车辆标签-捡漏 */
.car-info-wrapper  .car-title-icon-perfix.rare-one {
  // background-image: url(https://static.nuonuo.com.cn/zycmp/zcar-ilst-item-rare-one-20210113.png);
  // background-size: contain;
  // width: 40px;
}

/* 车辆标签-个人寄售 */
.car-info-wrapper  .car-title-icon-perfix.personal-consignment {
  // background-image: url(https://static.nuonuo.com.cn/zycmp/zcar-ilst-item-personal-consignment-20220304.png?v=1);
  // background-size: auto 100%;
  // width: 50px;
  // padding: 0px 36px;
}

.car-client-wrapper {
  position: absolute;
  bottom: 0;
  z-index: 300;
  left: 0;
  text-align: center;
  width: 100%;
  font-size: .7rem;
  background-color: rgb(216, 0, 20);
  color: #ffffff;
}

.car-discount-ribbon-wrapper {
  background-image: url('https://static.nuonuo.com.cn/zycmp/discount_ribbon.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  z-index: 300;
  width: 45px;
  height: 50px;
  top: -9px;
  left: 1px;
}

.car-discount-ribbon {
  color: #ffffff;
  font-size: 8px;
  font-weight: bolder;
  text-align: center;
  padding: 8px 0 0 0;
  box-sizing: border-box;
  text-align: center;
  width: 88%;
  line-height: 1.3;

  > .price-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.car-indicators-wrapper {
  width: 50px;
  height: 22px;
  position: absolute;
  left: 1px;
  bottom: 1px;
  z-index: 150;
}

.car-cover-wrapper.client .car-indicators-wrapper {
  bottom: 18px;
}

.car-indicators {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.car-item-icon {
  width: 22px;
  height: 22px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.car-item-icon-video {
  margin-right: 2px;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_video-play-button.png');
}

.car-item-icon-view360 {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car-detail_view360-button.png');
}

.car-cover-wrapper {
  flex: 1.1;
  margin: 0 10px 0 0;
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  align-self: flex-start;
  overflow: hidden;
}

.car-cover-wrapper::before,
.car-cover-wrapper::after {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
}

.car-cover-wrapper::before {
  z-index: 300;
}

.car-cover-wrapper::after {
  z-index: 200;
}

/* 抢先报 */
.car-cover-wrapper.early-access::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_early_access.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left right;
  left: 0;
  top: 0;
}

/* 抢先报 */
.car-cover-wrapper.market::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_market_tag.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  left: 0;
  top: 0;
}

/* 抢先报 w/ 被秒 */
.car-cover-wrapper.early-access-sold::before {
  background-color: rgba(255, 255, 255, 0.5);
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_early_access_sold.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  left: 0;
  top: 0;
}

.car-cover-wrapper.client.early-access-sold::before {
  background-color: rgba(255, 255, 255, 0.5);
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_early_access_sold-20210630.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  left: 0;
  bottom: 0;
}

/* 已预订 */
.car-cover-wrapper.ordered::before {
  background: url('https://static.nuonuo.com.cn/zycmp/car_cover_ordered.png');
  background-position: right bottom;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.2);
}

.car-cover-wrapper.client.ordered::before {
  bottom: 15px;
}

.car-cover-wrapper.newbie::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_newbie_without_fade_bg.png');
  background-position: right bottom;
  background-size: cover;
}

.car-cover-wrapper.newbie::after {
  display: none;
}

/* 已售 */
.car-cover-wrapper.sold::before {
  background: url('https://static.nuonuo.com.cn/zycmp/car_cover_sold.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 刚到店 & 已预定 */
.car-cover-wrapper.newbie-ordered::before {
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_newbie_ordered.png');
  background-size: cover;
  background-position: right bottom;
  background-repeat: no-repeat;
}

/* 刚到店 & 已售 */
.car-cover-wrapper.newbie-sold::before {
  background: url('https://static.nuonuo.com.cn/zycmp/car_cover_newbie_sold.png');
  background-size: cover;
  background-position: right bottom;
  background-repeat: no-repeat;
}

.car-cover {
  position: relative;
  z-index: 100;
}

.car-cover::before {
  content: '';
  display: block;
  padding-bottom: calc(100% / 3 * 2);
  width: 100%;
  box-sizing: border-box;
}

// 贷款审核中
.car-loan-reivew {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background-image: url('https://static.nuonuo.com.cn/zycmp/car_cover_existed_loan_review.png');
  background-size: cover;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  z-index: 300;
}

.car-cover > img {
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  object-fit: cover;
  margin: 0;
  height: 100%;
}

.car-cover-wrapper.client .car-cover > img {
  margin-top: -10px;
}

// .early-access-indicator
// - 2024.10.23
// - 抢先
.early-access-indicator {
  color: white;
  background: #D21213;
  font-size: .9rem;
  text-align: center;
  padding: 2px 0;
  line-height: 1;
  position: absolute;
  z-index: 200;
  width: 100%;
  letter-spacing: 2px;
  transform: rotate(-45deg);
  left: -38%;
  top: 9%;
}

.vehicle-rating-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  z-index: 300;
  font-size: .75rem;
  text-align: center;
}

@media (min-width: 640px) {
  .standard-item-wrapper {
    padding: 15px;
  }

  .car-cover-wrapper {
    flex: 1.2;
  }

  .car-discount-ribbon-wrapper {
    width: 70px;
    height: 60px;
    top: -5px;
  }

  .car-discount-ribbon {
    padding: 3px 0 0 0;
    font-size: 12px;
    width: 88%;
    line-height: 1.425;
  }

  .car-title {
    font-size: 1.025rem;
  }

  .car-meta {
    font-size: .85rem;
  }

  .car-price .current {
    font-size: 1.125rem;
  }

  .car-price .origin {
    font-size: .9rem;
  }

  .car-client-wrapper {
    font-size: .85rem;
  }

  // .early-access-indicator
  // - 2024.10.23
  // - 抢先
  .early-access-indicator {
    left: -42%;
    top: 10px;
  }

  .car-info-wrapper .car-tags .car-title-icon-perfix {
    padding: 1px 10px;
    font-size: .8rem;
  }

  .vehicle-rating-wrapper {
    min-width: 22px;
    height: 22px;
    line-height: 22px;
    font-size: .95rem;
  }
}

@media (prefers-color-scheme: dark) {
  .car-info-wrapper  .car-title-icon-perfix.diesel {
    background: #BC0C00;
  }

  .car-info-wrapper  .car-title-icon-perfix.new-energy {
    background: #077E4D;
  }

  .car-info-wrapper  .car-title-icon-perfix.manual {
    background: #0762AC;
  }

  .car-info-wrapper  .car-title-icon-perfix.wagon {
    background: #5A01AD;
  }

  .car-info-wrapper .car-title-icon-perfix.westward {
    background: #725227;
  }

  .car-client-wrapper {
    background: #5B010B;
  }
}
</style>
